import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IContentAddResponse, IContentResponse, IContents, IPresignedURLResponse, IResponseMessage } from '../../models';
import { ApiConstants } from '../../common';

@Injectable({
  providedIn: 'root',
})
export class ContentService {

  constructor(private http: HttpClient) { }

  getAllContents(): Observable<IContentResponse> {
    return this.http.get<IContentResponse>(ApiConstants.contents+`?source=admin`);
  }

  addContents(content: FormData): Observable<IContentAddResponse> {
    return this.http.post<IContentAddResponse>(ApiConstants.contents, content);
  }

  updateContents(content_id: number, content: FormData): Observable<IContents> {
    return this.http.put<IContents>(ApiConstants.contents + content_id + '/', content);
  }

  deleteContentsById(content_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(ApiConstants.contents + content_id + '/');
  }

  getPresignedURLForS3(file_name: string, file_type: string, file_size: number): Observable<IPresignedURLResponse> {
    return this.http.get<IPresignedURLResponse>(ApiConstants.presignedURLForS3 + '?file_name=' + file_name + '&content_type=' + file_type + '&file_size=' + file_size);
  }

  uploadFileToS3(presignedUrl: string, file: File): Observable<void> {
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          observer.next(xhr.response);
          observer.complete();
        } else {
          observer.error(new HttpErrorResponse({
            error: xhr.response,
            status: xhr.status,
            statusText: xhr.statusText
          }));
        }
      };

      xhr.onerror = () => {
        observer.error(new HttpErrorResponse({
          error: xhr.response,
          status: xhr.status,
          statusText: xhr.statusText || 'Unknown error'
        }));
      };

      xhr.open('PUT', presignedUrl, true);
      xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
      xhr.send(file);

      return () => xhr.abort();
    });
  }

}
